import { render } from "./UnsupportedCharacterPopup.vue?vue&type=template&id=2ab64e23&scoped=true"
import script from "./UnsupportedCharacterPopup.vue?vue&type=script&lang=js"
export * from "./UnsupportedCharacterPopup.vue?vue&type=script&lang=js"

import "./UnsupportedCharacterPopup.vue?vue&type=style&index=0&id=2ab64e23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab64e23"]])

export default __exports__